// extracted by mini-css-extract-plugin
export var addButton = "_fz-0";
export var border = "_fz-8";
export var check = "_fz-h";
export var danger = "_fz-6";
export var dropdownContainer = "_fz-1";
export var editModalBody = "_fz-j";
export var footerContainer = "_fz-i";
export var fullWidth = "_fz-a";
export var hide = "_fz-9";
export var icon = "_fz-3";
export var input = "_fz-7";
export var inputFlex = "_fz-b";
export var inputWrapper = "_fz-c";
export var manualFocus = "_fz-5";
export var optionButton = "_fz-4";
export var pillWrapper = "_fz-e";
export var pointer = "_fz-2";
export var showOverflow = "_fz-f";
export var tagsFlex = "_fz-d";
export var xButton = "_fz-g";